import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Icon } from "@iconify/react/dist/iconify.js";
import {
  getPurchasedItems,
  revertToGoodCondition,
} from "../../../redux/features/assetManagementSlice";
import { savePaginationData } from "../../../redux/features/globalDatagridSlice";
import GlobalDialog from "../../../components/mui/Dialogue/GlobalDialog";
import {
  CancelButton,
  SubmitButton,
} from "../../../components/mui/Buttons/Buttons";

const RevertToGoodCondition = ({ row, dispatchParams }) => {
  const [open, setOpen] = useState(false);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { loading } = useSelector((store) => store.assetmanagement);

  const initialValues = {
    backToGood: true,
    count: 1,
  };

  const schema = Yup.object({
    count: Yup.number()
      .required("Count is required")
      .positive("Count must be greater than 0")
      .integer("Count must be an integer")
      .test(
        "max-count",
        `Count must be less than or equal to ${row?.damagedCount}`,
        function (value) {
          return value <= row?.damagedCount;
        }
      ),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: (values) => {
      const data = { ...values };
      if (row) {
        const updateData = { ...data, purchaseId: row.purchaseID };
        dispatch(revertToGoodCondition(updateData)).then((res) => {
          if (res.payload.status === "error") {
            enqueueSnackbar(res.payload.message, {
              variant: "error",
            });
          } else if (res.payload.status === "success") {
            handleCancel();
            dispatch(getPurchasedItems(dispatchParams));
            dispatch(
              savePaginationData({ ...paginationData, openAnchor: false })
            );
            enqueueSnackbar(res.payload.message, {
              variant: "success",
            });
          }
        });
      }
    },
  });


  const handleCancel = () => {
    setOpen(false);
    formik.resetForm();
  };

  return (
    <GlobalDialog
      maxWidth={"sm"}
      fullWidth
      title={"Revert to Good Condition"}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      popupButton={
        <>
          <Button
            size="small"
            variant="outlined"
            onClick={() => setOpen(true)}
          >
            Mark as Functional
          </Button>
        </>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box component={Paper} elevation={2} p={2} borderRadius={2}>
                <Stack direction={"row"} alignItems="center" spacing={1}>
                  <Icon
                    icon="arcticons:okta-verify"
                    width="25"
                    height="25"
                    style={{ color: "#7e4d8b" }}
                  />
                  <Box>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="backToGood"
                            checked={formik.values.backToGood}
                            // onChange={formik.handleChange}
                          />
                        }
                        label="Revert to Good Condition"
                      />
                    </FormGroup>
                  </Box>
                </Stack>
                <Box my={1}>
                  <TextField
                    autoComplete="off"
                    fullWidth
                    id="count"
                    label="Count"
                    name="count"
                    value={formik.values.count}
                    onChange={formik.handleChange}
                    error={formik.touched.count && Boolean(formik.errors.count)}
                    helperText={formik.touched.count && formik.errors.count}
                  />
                </Box>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                <Stack direction={"row"} spacing={1}>
                  <CancelButton action={() => handleCancel()}>
                    Cancel
                  </CancelButton>
                  <SubmitButton disabled={loading} type="submit">
                    {loading ? "Submiting..." : "Submit"}
                  </SubmitButton>
                </Stack>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default RevertToGoodCondition;
